import '.an{position:relative;}.ssr-plugin'
import '.t{background-color:var(--palette-white);}.ssr-plugin'
import '.jl{border-radius:20px;}.ssr-plugin'
import '.u{border:var(--border-subtle);}.ssr-plugin'
import '.br{padding:1.5rem;}.ssr-plugin'
import '.l{width:100%;}.ssr-plugin'
import '.jm{transition:box-shadow 0.2s ease;}.ssr-plugin'
import '.gz{width:2rem;}.ssr-plugin'
import '.bd{height:2rem;}.ssr-plugin'
import '.g8{border-radius:50%;}.ssr-plugin'
import '.jn{border:1px solid var(--palette-blue-800);}.ssr-plugin'
import '.d{display:flex;}.ssr-plugin'
import '.ab{justify-content:center;}.ssr-plugin'
import '.r{align-items:center;}.ssr-plugin'
import '.ah{flex-shrink:0;}.ssr-plugin'
import '.jo{margin-left:1rem;}.ssr-plugin'
import { Style, styled } from 'inlines'
import { Text } from '@app/components/core/typography/Text'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowUpRight } from '@fortawesome/pro-regular-svg-icons'
import Row from '@app/components/layout/Row'
import Column from '@app/components/layout/Column'
import { Title } from '@app/components/core/typography/Title'

export interface SubsidyCardProps {
  title: string
  description: string
  style?: Style
  onClick?: () => void
}

export const SubsidyCard = ({
  title,
  description,
  style,
  onClick,
}: SubsidyCardProps) => {
  return (
    <styled.div className="an t jl u br l jm"
      data-testid="subsidy-card"
      onClick={onClick}
      style={{
        cursor: onClick ? 'pointer' : 'default',
        '&:hover': onClick
          ? {
              boxShadow: '0 4px 14px 0 rgba(0, 0, 0, 0.08)',
            }
          : {},
        ...style,
      }}
    >
      <Column gap="0.625rem" alignItems="stretch">
        {/* Header Section */}
        <Row
          style={{
            justifyContent: 'space-between',
            alignItems: 'center',
          }}
        >
          {/* Title */}
          <Title.H5 style={{ color: 'var(--palette-blue-800)' }}>
            {title}
          </Title.H5>

          {/* Circular Icon */}
          <div className="gz bd g8 jn d ab r ah jo"
          >
            <FontAwesomeIcon
              icon={faArrowUpRight}
              style={{
                color: 'var(--palette-blue-800)',
                height: '1.25rem',
                width: '1.25rem',
              }}
            />
          </div>
        </Row>

        {/* Body Section */}
        <Text.Medium
          style={{
            color: 'var(--palette-blue-600)',
          }}
        >
          {description}
        </Text.Medium>
      </Column>
    </styled.div>
  )
}
